export default __webpack_public_path__ + "static/take-a-look-f2c68cb4b7213d5fd9b2678fee4f26fc.png";